export const EVENT = {
  TERM: "Terms and conditions",
  POLICY: "Policies",
  LOGIN_SUCCESS: "Login succeeded",
  LOGIN_FAILURE: "Login failed",
  SIGNUP: "Sign up",
  FORGOT_PASSWORD: "Password reset",
  UPDATE_PROFILE: "Profile updated",
  ENABLE_2FA: "Two-factor enabled",
  EXPORT_QUOTA: "Export quota",
  DOWNLOAD_QUOTA: "Download quota",
  PROJECT: {
    CREATE: "Project created",
    FILTER: "Project list filtered",
    SHARE: "Project shared",
    SEARCH: "Project search",
  },
  COMPONENT: {
    CREATE: "Component created",
    FILTER: "Component list filtered",
  },
  BUILD: {
    CREATE: "Build created",
    FILTER: "Build list filtered",
  },
  DOWNLOAD: {
    BUILD_SUCCESS: "Build files download succeeded",
    BUILD_FAILURE: "Build files download failed",
    COMPONENT_SUCCESS: "Component files download succeeded",
    COMPONENT_FAILURE: "Component files download failed",
    FILE_SUCCESS: "File download succeeded",
    FILE_FAILURE: "File download failed",
    BOM_SUCCESS: "BOM export succeeded",
    BOM_FAILURE: "BOM export failed",
    CONVERSATION_SUCCESS: "Conversation files download succeeded",
    CONVERSATION_FAILURE: "Conversation files download failed",
    INVITEE_SUCCESS: "Invitee file download succeeded",
    INVITEE_FAILURE: "Invitee file download failed",
  },
  KEY_DECRYPT: {
    VAULT_SUCCESS: "Vault key unlocked",
    VAULT_FAILURE: "Vault key unlock failed",
    PRIVATE_SUCCESS: "Private key ready",
    PRIVATE_FAILURE: "Private key unlock failed",
    PROJECT_SUCCESS: "Project key ready",
    PROJECT_FAILURE: "Project key unlock failed",
    BUILD_SUCCESS: "Build key ready",
    BUILD_FAILURE: "Build key unlock failed",
    CONVERSATION_SUCCESS: "Conversation key ready",
    CONVERSATION_FAILURE: "Conversation key unlock failed",
    SHARE_SUCCESS: "Invitation key received",
    SHARE_FAILURE: "Invitation key failed",
    AUTOFIX_SUCCESS: "Encryption keys auto-fix succeeded",
    AUTOFIX_FAILURE: "Encryption keys auto-fix failed",
  },
  KEY_ENCRYPT: {
    SHARE_SUCCESS: "Invitee invite key sent",
    SHARE_FAILURE: "Invitee invite key failed",
  },
  FILE_CRYPTO: {
    ENCRYPT_SUCCESS: "Upload encryption succeeded",
    ENCRYPT_FAILURE: "Upload encryption failed",
    DECRYPT_SUCCESS: "File decryption succeeded",
    DECRYPT_FAILURE: "File decryption failed",
    VERIFY_SUCCESS: "File signature verified",
    VERIFY_FAILURE: "File signature failed",
  },
  COMMENT: {
    VIEW: "Comments viewed",
    CREATE: "Comment posted",
  },
  BOM: {
    ADD_SUPPLIER: "BOM supplier added",
    ADD_COLUMN: "BOM column added",
    UPDATE_COLUMN: "BOM column updated",
    SYNC_SUPPLIER_STOCKS: "BOM supplier stock synced",
  },
  WORKSPACE: {
    SWITCH_SUCCESS: "Workspace switched",
    SWITCH_FAILURE: "Workspace switch failed",
  },
  CONVERSATION: {
    FILTER: "Conversations filtered",
    SEARCH: "Conversations search",
    ENABLE: "Conversation notifications on",
    DISABLE: "Conversation notifications off",
  },
  INVITEE: {
    SEND_INVITATION: "Invitation sent",
    REMOVE: "Invitee removed",
    SHARE_KEY: "Share key",
  },
}
